import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Pill } from '../../components/ui'
import { statusTone } from './adminPageFormatters'

export function CodeValue({ children }: { children: ReactNode }) {
  return <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, overflowWrap: 'anywhere' }}>{children}</span>
}

export function DataPill({ value }: { value: string | null | undefined }) {
  const { t } = useTranslation()
  const label = value || t('admin.common.none')
  return <Pill tone={statusTone(value)} size="sm" dot>{label}</Pill>
}

export function LoadingState({ label }: { label: string }) {
  return (
    <Card>
      <div style={{ color: 'var(--fg-muted)', fontWeight: 700 }}>{label}</div>
    </Card>
  )
}

export function ErrorState({ title, body, onRetry }: { title: string; body: string; onRetry?: () => void }) {
  const { t } = useTranslation()
  return (
    <Card style={{ borderColor: 'var(--danger-100)', background: 'var(--bg-card)' }}>
      <div style={{ fontWeight: 900, color: 'var(--danger)' }}>{title}</div>
      <div style={{ marginTop: 6, color: 'var(--fg-muted)', fontSize: 14 }}>{body}</div>
      {onRetry && (
        <button type="button" onClick={onRetry} style={{ marginTop: 14, border: 'none', background: 'transparent', color: 'var(--brand-700)', fontFamily: 'inherit', fontWeight: 800, cursor: 'pointer', padding: 0 }}>
          {t('admin.common.retry')}
        </button>
      )}
    </Card>
  )
}

export function EmptyState({ title, body }: { title: string; body: string }) {
  return (
    <Card>
      <div style={{ fontWeight: 900, color: 'var(--brand-900)' }}>{title}</div>
      <div style={{ marginTop: 6, color: 'var(--fg-muted)', fontSize: 14 }}>{body}</div>
    </Card>
  )
}

